/**
* PCのグローバルナビのホバーエフェクト
* @constructor
* @param {selector} el - セレクタ
* @param {options} object - オプション
*/
module.exports = ExpandNav = function(el, options) {
  this.element = $(el);
  this.breakpoint = options.bp;
  this.group = this.element.data('navgroup');
  this.target = $('.js-ExpandNavTarget[data-navgroup="' + this.group + '"]');
  this.children = $('.js-ExpandNavTarget');
  this.win = $(window);
  this.init();
};
/**
* init
*/
ExpandNav.prototype.init = function() {
  var self = this;

  var timer = false;
  self.element.on('mouseenter touchstart', function() {// touchstartはタブレット対応
    // console.log('element on');
    // マウスがちょっとブレて上を通過したくらいでは開かないようタイマー設定
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      self.deactivateAll();
      self.activate();
    }, 150);
  });
  // 250ms以内にカーソルが出ていったら開かない、開いていたら閉じる
  self.element.on('mouseleave', function() {
    // console.log('element off');
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      self.deactivate();
    }, 1000);
  });

  self.target.on('mouseenter touchstart', function() {
    // console.log('target on');
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      self.deactivateAll();
      self.activate();
    }, 150);
  });
  self.target.on('mouseleave', function() {
    // console.log('target off');
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      self.deactivate();
    }, 1000);
  });

  var timer2 = false;
  self.win.on('resize', function() {// SPビューになったら全部閉じる
    if (timer2 !== false) {
      clearTimeout(timer2);
    }
    timer2 = setTimeout(function() {
      self.onResize();
    }, 100);
  });
};

/**
* activate
*/
ExpandNav.prototype.activate = function() {
  var self = this;
  if (self.target.hasClass('is-Active')) return false;
  self.target.addClass('is-Active');
};

/**
* deactivate
*/
ExpandNav.prototype.deactivate = function() {
  var self = this;
  self.target.removeClass('is-Active');
};

/**
* deactivate all
*/
ExpandNav.prototype.deactivateAll = function() {
  var self = this;
  self.children.removeClass('is-Active');
};

/**
* resize
*/
ExpandNav.prototype.onResize = function() {
  var self = this;

  var w = self.win.width();
  var isEnabledVP = (w >= self.breakpoint);

  if (w < self.breakpoint) {
    self.deactivateAll();
  }
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/expandNav.js
// module id = 5
// module chunks = 0